import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=340493b0&scoped=true&"
import script from "./Leader.vue?vue&type=script&lang=js&"
export * from "./Leader.vue?vue&type=script&lang=js&"
import style0 from "./Leader.vue?vue&type=style&index=0&id=340493b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340493b0",
  null
  
)

export default component.exports